import WashdayClientSingleton from './WashdayClientSingleton';

export const createSupplyV2 = async (storeId: string, data: {
  name: string;
  code: string;
  purchaseUnit: string;
  usageUnit: string;
  usageFactor: number;
  unitPrice: number;
  stock: number;
  alertOnStock: number;
  supplyActivityHistory: []
}) => {
  try {
    return await WashdayClientSingleton.getInstance().supplies.createSupply(storeId, data);
  } catch (e) {
    console.log('ERROR createSupplyV2', e);
    throw e;
  }
};

export const updateSupplyByIdV2 = async (storeId: string, id: string, data: {
  alertOnStock: number;
  name: string;
  code: string;
  purchaseUnit: string;
  usageUnit: string;
  usageFactor: number;
  unitPrice: number;
}) => {
  try {
    return await WashdayClientSingleton.getInstance().supplies.updateSupplyById(storeId, id, data);
  } catch (e) {
    console.log('ERROR updateSupplyByIdV2', e);
    throw e;
  }
};

export const addSupplyStockV2 = async (storeId: string, id: string, data: {
  newStock: number,
}) => {
  try {
    return await WashdayClientSingleton.getInstance().supplies.addSupplyStock(storeId, id, data);
  } catch (e) {
    console.log('ERROR addSupplyStockV2', e);
    throw e;
  }
};

export const deleteSupplyByIdV2 = async (storeId: string, id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().supplies.deleteSupplyById(storeId, id);
  } catch (e) {
    console.log('ERROR deleteSupplyByIdV2', e);
    throw e;
  }
};

export const getSuppliesV2 = async (storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().supplies.getSupplies(storeId);
  } catch (e) {
    console.log('ERROR getSuppliesV2', e);
    throw e;
  }
};

export const getSupplyByIdV2 = async (storeId: string, id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().supplies.getSupplyById(storeId, id);
  } catch (e) {
    console.log('ERROR getSupplyByIdV2', e);
    throw e;
  }
};

export const getSupplyHistoryV2 = async (storeId: string, id: string, params: {
  pageNum: number,
  limit: number
}) => {
  try {
    return await WashdayClientSingleton.getInstance().supplies.getSupplyHistory(storeId, id, params);
  } catch (e) {
    console.log('ERROR getSupplyHistoryV2', e);
    throw e;
  }
};



